import {z} from 'zod';
import {
	editEffectsSortOrder,
	type EditEffectsSortOrderParams,
	getSortField,
	type GetSortFieldParams,
	getSortOrder,
	type GetSortOrderParams,
	SortOrder,
	SortSchema,
} from '@netx/core-next/schema';
import {GroupUserField, type IGroupUser} from './groupUserSchema';

export const GROUP_USERS_SORTABLE_FIELDS = [
	GroupUserField.firstName,
	GroupUserField.lastName,
	GroupUserField.email,
	// GroupUserField.userType,
	GroupUserField.username,
] as const;

export const GroupUsersSortSchema = SortSchema.omit({
	field: true,
}).extend({
	field: z.enum(GROUP_USERS_SORTABLE_FIELDS),
});

export type GroupUsersSort = z.infer<typeof GroupUsersSortSchema>;

export const GroupUsersSortableField = z.enum(GROUP_USERS_SORTABLE_FIELDS).enum;

export const GROUP_USERS_DEFAULT_SORT_FIELD = GroupUsersSortableField.firstName;

export const GROUP_USERS_DEFAULT_SORT_ORDER = SortOrder.ASCENDING;

/** will return the sort passed in if valid/specified, otherwise will return the defaults for the invalid/unspecified */
export const getGroupUsersDefaultSort = (
	sort: Partial<GroupUsersSort> = {},
): GroupUsersSort => ({
	field: getGroupUsersSortField({sortField: sort.field}),
	order: getGroupUsersSortOrder({sortOrder: sort.order}),
});

/** will return the passed in sort field if valid, otherwise will retutn the default sort field */
export const getGroupUsersSortField = (
	params: Omit<
		GetSortFieldParams<(typeof GROUP_USERS_SORTABLE_FIELDS)[number]>,
		'defaultSortField' | 'sortableFields'
	>,
) =>
	getSortField({
		...params,
		sortableFields: GROUP_USERS_SORTABLE_FIELDS,
		defaultSortField: GROUP_USERS_DEFAULT_SORT_FIELD,
	});

/** will return the passed in sort order if valid, otherwise will return the default sort order */
export const getGroupUsersSortOrder = (
	params: Omit<GetSortOrderParams, 'defaultSortOrder'>,
) =>
	getSortOrder({
		...params,
		defaultSortOrder: GROUP_USERS_DEFAULT_SORT_ORDER,
	});

/** given the original data, the new data, and the current sort, determine if the sort order was effected */
export const groupUserEditEffectsOrder = (
	params: Omit<
		EditEffectsSortOrderParams<
			IGroupUser,
			(typeof GROUP_USERS_SORTABLE_FIELDS)[number]
		>,
		'sortableFields'
	>,
) =>
	editEffectsSortOrder({
		...params,
		sortableFields: GROUP_USERS_SORTABLE_FIELDS,
	});
